// Get all review video cards safely
const reviewCards = document.querySelectorAll('.review-card__video');

if (!reviewCards.length) {
    console.warn("⚠ No .review-card__video elements found. Skipping video setup.");
}

reviewCards.forEach((card, index) => {
    try {
        const video = card.querySelector('.review-card__video-el');
        const playBtn = card.querySelector('.review-card__video-play-btn');

        // Check required elements
        if (!video) {
            console.error(`❌ Missing video element (.review-card__video-el) in card index ${index}`);
            return;
        }
        if (!playBtn) {
            console.error(`❌ Missing play button (.review-card__video-play-btn) in card index ${index}`);
            return;
        }

        // CLICK PLAY BUTTON → play video
        playBtn.addEventListener('click', (e) => {
            try {
                e.stopPropagation();
                if (video.paused) {
                    video.play().catch(err => {
                        console.error(`❌ Failed to play video in card index ${index}`, err);
                    });
                    playBtn.style.display = "none";
                }
            } catch (error) {
                console.error(`❌ Error while trying to play video in card index ${index}`, error);
            }
        });

        // CLICK VIDEO → pause video
        video.addEventListener('click', () => {
            try {
                if (!video.paused) {
                    video.pause();
                    playBtn.style.display = "flex";
                }
            } catch (error) {
                console.error(`❌ Error while trying to pause video in card index ${index}`, error);
            }
        });

        // WHEN VIDEO ENDS → show play button again
        video.addEventListener('ended', () => {
            try {
                playBtn.style.display = "flex";
            } catch (error) {
                console.error(`❌ Error while handling video end in card index ${index}`, error);
            }
        });

    } catch (error) {
        console.error(`❌ Unexpected error initializing video card at index ${index}`, error);
    }
});



const swiperTestimonial = new Swiper(".testimonial-slider", {
    slidesPerView: 1, // Mobile default
    spaceBetween: 16,
    grabCursor: true,
    slidesOffsetAfter: 220,
    freeMode: true,
    freeModeMomentum: true,
    freeModeMomentumRatio: 0.4,
    resistanceRatio: 0.92,
    speed: 450,

    breakpoints: {
        0: {
            slidesPerView: 1.5,
            spaceBetween: 24,
        },
        560: {
            slidesPerView: 2, // Desktop
            spaceBetween: 24,
        },
    }

});